// Site styles
import "../styles/index.css"

// Alpine.js + plugins (self-hosted; replaces the jsDelivr CDN scripts).
// Register plugins before calling Alpine.start() per Alpine docs.
import Alpine from "alpinejs"
import intersect from "@alpinejs/intersect"
import collapse from "@alpinejs/collapse"
import focus from "@alpinejs/focus"
import setupShapeGrids from "./shape_grid"
import setupDotFields from "./dot_field"
import agentReadsLayers from "./agent_reads_layers"
import setupHeroMotion from "./hero_motion"
import setupAnalytics from "./analytics"
import { setupAttribution } from "./marketing_attribution.js"
import setupContactForm from "./contact_form.js"
import setupMarketingCtas from "./marketing_cta.js"

Alpine.plugin(intersect)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine
Alpine.data("agentReadsLayers", agentReadsLayers)
Alpine.start()

setupAttribution()
setupContactForm()
setupMarketingCtas()
setupAnalytics()

// Scroll-reveal: trigger .revealed on .reveal elements as they enter the viewport.
// Uses a native IntersectionObserver so it works independently of Alpine.js.
document.addEventListener("DOMContentLoaded", () => {
  if (!("IntersectionObserver" in window)) {
    // Fallback for very old browsers: reveal everything immediately
    document.querySelectorAll(".reveal").forEach(el => el.classList.add("revealed"))
    return
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed")
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.1 }
  )

  document.querySelectorAll(".reveal").forEach(el => observer.observe(el))
})

// Animated hero grid background (opt-in per hero via `shape_grid: true`).
document.addEventListener("DOMContentLoaded", setupShapeGrids)

document.addEventListener("DOMContentLoaded", setupDotFields)

// Looping product animations in project heroes (opt-in via `[data-hero-motion]`,
// preset picked by `data-hero-motion-preset`). Pauses off-screen; static frame
// for reduced motion.
document.addEventListener("DOMContentLoaded", setupHeroMotion)
